export default "__VITE_ASSET__nqOpkUul__"